<template>
  <div id="container">
    <out-an-invoice-information ref="outAnInvoiceInformationRefs"></out-an-invoice-information>
    <div class="box-table" style="margin-top:20px">
      <div class="title-font-style">
        <span>开票清单</span>
      </div>
      <el-table
        style="margin-top:20px"
        border
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        max-height="378"
      >
        <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{scope.row.contractCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户合同编号" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.customerContractCode||'--'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="cusName" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="approval line-limit-length" @click="toKeHu(scope.row)">{{scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="品牌" prop="brandName" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
        <el-table-column label="销售单价" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.cbPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="销售总额" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.cbTotal|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="货期" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
        </el-table-column>
        <el-table-column label="数量" prop="notInvoice" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="footer-but" style="padding-bottom:0px">
      <el-button @click="onSubmit" type="primary">申请开票</el-button>
      <div style="display: flex;padding-bottom:5px;">
        <i class="el-icon-warning-outline" style=" margin-top: 12px;"></i>
        <span class="warning-text">开票清单中，若存在未发货产品，申请开票需要上级审核。开票审核通过后请及时联系处理人领取</span>
      </div>
    </div>
    <!-------------- 申请开票 确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="确认开票"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import outAnInvoiceInformation from './billManage/outAnInvoiceInformation'
import {
  orderContractApplyForInvoice,
  orderContractApplyForInvoiceCommit,
  queryInvoiceInfoPersonAndMessage
} from '@/api/sell/sellManage'
import OpenOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'out-an-invoice-information': outAnInvoiceInformation
  },
  data() {
    return {
      isF: {},
      params: {},
      queryParams: {},
      content: '', // 确认申请开票内容
      list: [], // 开票区 列表
      totals: 0, // 开票总额
      flag: true
    }
  },
  mounted() {
    if (this.$store.state.Sell.tempBotList.length !== 0) {
      this.list = this.$store.state.Sell.tempBotList
      this.cusId = this.$route.query.cusId
      queryInvoiceInfoPersonAndMessage(this.cusId, this.list).then((res) => {
        if (res.data.code === 200) {
          const obj = {
            invocieAmountLimit: res.data.obj.invocieAmountLimit,
            bilingType: '销售货款',
            ...res.data.obj.customerInvoice
          }
          this.$refs.outAnInvoiceInformationRefs.init(obj)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    } else {
      this.$router.push({ name: 'contractInvoicingManagement' })
    }
  },
  methods: {
    // 申请开票
    onSubmit() {
      this.queryParams = this.$refs.outAnInvoiceInformationRefs.queryParams
      if (
        !this.queryParams.invoiceType ||
        !this.queryParams.isMeger ||
        !this.queryParams.ciTaxcode ||
        !this.queryParams.ciBankcode ||
        !this.queryParams.ciTaxaddress ||
        !this.queryParams.ciBank ||
        !this.queryParams.ciPhone
      ) {
        this.$message.error('请填写完整开票信息！')
        return
      }
      if (this.$refs.outAnInvoiceInformationRefs.isShow) {
        this.$message.error('请保存收票信息！')
        return
      }
      if (
        !this.queryParams.ciRecevierPhone ||
        !this.queryParams.ciRecevier ||
        !this.queryParams.ciRecevierProvince
      ) {
        this.$message.error('请填写收票信息！')
        return
      }
      Object.assign(this.queryParams, {
        isMergen: Number(this.queryParams.isMeger)
      })
      this.params = {
        ...this.queryParams,
        customerInvoice: this.queryParams,
        mark: this.queryParams.invoiceMark,
        orderContractInvoiceStateVoList: this.list
      }
      orderContractApplyForInvoice(this.params).then((res) => {
        if (res.data.code === 200) {
          this.isF = res.data.obj
          if (this.isF.isApproval) {
            this.content = '开票申请发起后无法撤回，是否确认开票？'
          } else {
            this.content =
              '当前开票清单中存在不满足开票产品，确认后将由上级审核。'
          }
          this.$refs.OpenOrCloseRefs.onInitial()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 二次确认弹窗
    onUpdataState() {
      this.params.map = this.isF
      orderContractApplyForInvoiceCommit(this.params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('已申请开票，请等待审核！')
          this.$router.push({ name: 'contractInvoicingManagement' })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    toHeTong(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.id, cusId: row.cusId }
      })
    },
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.cusId }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>

<style>
</style>
